import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  itemKeyWordList: [],
  singleItemKeyWordList: [],
  itemWiseKeywordList: [],
  keywordTagList: [],
  solaByNameList: []
};

const keyWordSlice = createSlice({
  name: 'keyWordSlice',
  initialState,
  reducers: {
    setItemKeyWordList: (state, action) => ({
      ...state,
      itemKeyWordList: action.payload
    }),
    setSingleItemKeyWordList: (state, action) => ({
      ...state,
      singleItemKeyWordList: action.payload
    }),
    setItemWiseKeywordList: (state, action) => ({
      ...state,
      itemWiseKeywordList: action.payload
    }),
    setKeywordTagList: (state, action) => ({
      ...state,
      keywordTagList: action.payload
    }),
    setSoldByNameList: (state, action) => ({
      ...state,
      solaByNameList: action.payload
    })
  }
});

export const { setItemKeyWordList, setSingleItemKeyWordList, setItemWiseKeywordList, setKeywordTagList, setSoldByNameList } =
  keyWordSlice.actions;

export default keyWordSlice.reducer;
